import http from "../../http-common";

export default class ImpexiumEmailUser {
  postEmailCreate(userInfo: { id: string, address: string, type: string, action: string, oldAddress: string }) {
    let url = ``;
    if (userInfo.action === 'create')
      url = `/impexium/add-email`;
    else
      url = `/impexium/update-email`;

    return http.post(url, userInfo);
  }
}